"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Paragraph = _interopRequireDefault(require("../../Typography/Paragraph/Paragraph"));

require("./TabContainer.css");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function TabContainerDiv(_ref) {
  var children = _ref.children,
      size = _ref.size,
      width = _ref.width;
  var styles = {
    width: width
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: styles,
    className: size === 'small' ? 'tab-container tab-small' : 'tab-container'
  }, _react.default.Children.map(children, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      className: "tab ".concat(child.props.className)
    }, /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
      fontSize: size === 'small' ? '12B' : '16B'
    }, child.props.children));
  }));
}

function MobileTabContainer(_ref2) {
  var children = _ref2.children,
      size = _ref2.size,
      width = _ref2.width;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var popperAnchor = (0, _react.useRef)(null);

  var handleClick = function handleClick(event) {
    event.stopPropagation();
    setOpen(!open);
  };

  var selectedItem = children.find(function (c) {
    var _c$props;

    return !!((_c$props = c.props) !== null && _c$props !== void 0 && _c$props.className) && c.props.className.indexOf('active') !== -1;
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: popperAnchor,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(TabContainerDiv, {
    size: size,
    width: width
  }, selectedItem)), /*#__PURE__*/_react.default.createElement(_core.Popper, {
    open: open,
    anchorEl: popperAnchor.current,
    placement: "bottom",
    transition: true,
    modifiers: {
      offset: {
        enabled: true,
        offset: '0, 16'
      }
    },
    style: {
      zIndex: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, null, /*#__PURE__*/_react.default.createElement(_core.ClickAwayListener, {
    onClickAway: function onClickAway() {
      return setOpen(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_core.List, null, children.map(function (child, index) {
    return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
      key: index,
      className: "tab-popper-item ".concat(child === selectedItem ? 'selected' : ''),
      onClick: function onClick() {
        return setOpen(false);
      }
    }, child);
  }))))));
}
/**
 * @visibleName Navigation Tabs
 */


function TabContainer(_ref3) {
  var children = _ref3.children,
      size = _ref3.size,
      width = _ref3.width,
      withPopper = _ref3.withPopper;

  if (withPopper) {
    return /*#__PURE__*/_react.default.createElement(MobileTabContainer, {
      size: size,
      width: width
    }, children);
  }

  return /*#__PURE__*/_react.default.createElement(TabContainerDiv, {
    size: size,
    width: width
  }, children);
}

TabContainer.propTypes = {
  /** Size of tab */
  size: _propTypes.default.oneOf(['big', 'small']),

  /** Elements to be rendered as TABS, use link, active class name 'active' */
  children: _propTypes.default.node.isRequired,

  /** Width of the tab container */
  width: _propTypes.default.string,

  /** Display as popper, used for mobile screens */
  withPopper: _propTypes.default.bool
};
TabContainer.defaultProps = {
  size: 'big',
  width: '100%'
};
var _default = TabContainer;
exports.default = _default;